import React, { useEffect, useState } from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  FormGroup,
  Form,
} from "reactstrap";
import "./index.css";
import { useDispatch, useSelector } from "react-redux";
import SvgImage from "../../Icons/Icons";
import { useNavigate } from "react-router-dom";
import Papa from 'papaparse';
import TripStatusData from "../../TripAnalysis/SubComponents/TripDataView";
import BulkFuelVendorView from "../../VendorNew/Components/BulkFuelVendorView";
import * as XLSX from 'xlsx';
import BulkProcessScreen from "../../subComponents/BulkProcessScreen";


function ShowExcelV3(props) {
  const { toggle, modal, setModal, navigatedFrom, fileSave,noramlData ,type,setFileSave,func,setRefresh,
    refresh} = props;
  console.log("navigatedFrom", navigatedFrom, fileSave);
  const [data, setData] = useState([]);
  const [next, setNext] = useState(false);


const handleFileChange = (file) => {
    const reader = new FileReader();
    reader.onload = (e) => {
        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, { type: 'array' });
        const firstSheet = workbook.Sheets[workbook.SheetNames[0]];
        const jsonData = XLSX.utils.sheet_to_json(firstSheet, { header: 1 });
  
        if (jsonData.length) {
          const headers = jsonData[0].map(header => ({
            name: header,
            selector: row => row[header],
            wrap: true,
          }));
  
          const rows = jsonData.slice(1).map(row => {
            const rowData = {};
            jsonData[0].forEach((key, index) => {
              rowData[key] = row[index];
            });
            return rowData;
          });
  
        //   setColumns(headers);
          setData(rows);
          console.log('nrnioernio',rows)
        }
      };
  
      reader.readAsArrayBuffer(file);
};

useEffect(() => {
  console.log("sbshjbsjhsbjshb",fileSave);
  if (fileSave) {
    const file = fileSave;
    const reader = new FileReader();
    reader.onload = (e) => {
        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, { type: 'array' });
        const firstSheet = workbook.Sheets[workbook.SheetNames[0]];
        const jsonData = XLSX.utils.sheet_to_json(firstSheet, { header: 1 });
  
        if (jsonData.length) {
          const headers = jsonData[0].map(header => ({
            name: header,
            selector: row => row[header],
            wrap: true,
          }));
  
          const rows = jsonData.slice(1).map(row => {
            const rowData = {};
            jsonData[0].forEach((key, index) => {
              rowData[key] = row[index];
            });
            return rowData;
          });
  
        //   setColumns(headers);
          setData(rows);
          console.log('nrnioernio',rows)
        }
      };
  
      reader.readAsArrayBuffer(file);
  }
  else if(noramlData){
    setData(noramlData);
  }
}, [fileSave]);
  console.log("data......", data);


  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleClose = () => {
    setModal(!modal);
  };



  // filesave has csv file exctract the data from it and show it in the table

  return (
    <div>
      <Modal
        isOpen={modal}
        onHide={handleClose}
        className=" modal-dialog-centered model-width model-Radius"
        toggle={toggle}
        aria-labelledby="myModalLabel2"
      >
        <ModalBody
          className="transactionModalBody"
          //   style={{ marginTop: "25px" }}
        >
          <div className="closeBtnWithBackground" onClick={handleClose}>
            <SvgImage
              classname="close-btn-text"
              style={{ width: "10%", height: "10%" }}
              name="crossBtnWIthBackground"
              width="20%"
              height="20%"
            />
          </div>
          <div
            style={{
              marginTop: " 30px",
              display: "flex",
              justifyContent: "space-between",
            }}

            //   className="PGCollectionBox"
          >
            <div
              className="PGCollectiontText"
              style={{
                marginLeft: "50px",
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              {type == "tripView" ? "Trip Data" : "Bulk Upload"}
            </div>
            {fileSave ? (
              <div className="d-flex">
                <div>Uploaded File :</div>
                <div style={{ margin: "0 0 0 10px" }}>{fileSave?.name}</div>
              </div>
            ) : (
              <></>
            )}
          </div>
          <div>
            <div
              style={{
                height: "400px",
                minHeight: "400px",
                overflowY: "scroll",
              }}
            >
              {type == "tripView" ? (
                <TripStatusData data={data} />
              ) : type == "fuelVendor" ? (
                <BulkFuelVendorView data={data} />
              ) : (
                ""
              )}
            </div>
          </div>
          {fileSave ? (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                margin: "20px 0 0 0",
              }}
            >
              <label for="file-upload2" class="custom-file-upload3">
                <input
                  id="file-upload2"
                  type="file"
                  onChange={async (e) => {
                    const img = e?.target.files[0];
                    setFileSave(img);
                    handleFileChange(img);
                    //   console.log("image...", e?.target.files[0]);
                    //   setBulkTransfer(1);
                  }}
                />
                <div
                  className="greenButtonNew btn-secondary"
                  style={{ width: "160px", padding: "5px" }}
                >
                  Re-Upload
                </div>
              </label>
              <label class="custom-file-upload3">
                <div
                  className="greenButtonNew btn-secondary"
                  style={{ width: "160px", padding: "5px" }}
                  onClick={() => {
                    func(fileSave)
                    setNext(true)
                }}
                  
                >
                  Next
                </div>
              </label>
            </div>
          ) : (
            <></>
          )}
          {next ? (
            <BulkProcessScreen
              toggle={() => setNext(!next)}
              modal={next}
              setModal={setNext}
              fileSave={fileSave}
              setFileSave={setFileSave}
              setView = {handleClose}
              setRefresh={setRefresh}
              refresh={refresh}
            />
          ) : (
            <></>
          )}
        </ModalBody>
      </Modal>
    </div>
  );
}

export default ShowExcelV3;
